import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import DashBoardView from './../dashboard/dashboard-view.js';
import FilesView from './../files/tcfile-view.js';
import FileDetailView from './../files/tcfile-detail-view.js';
import ReportsView from './../reports/report-view.js';
import TcsView from './../coordinators/coordinators-view.js';
import MakeListingView from './../files/make-listing-detail-view.js';
import MakeTransactionView from './../files/make-transaction-detail-view.js';
import MainTabs from './main-tabs.js';
import Cons, { roles } from '../../isomorphic/cons';
import Header from '../shared/header';
import Footer from '../shared/footer';
import LoadingIndicator from '../shared/loading-indicator';
import AgentView from '../agents/agent-view';
import AgentProfileView from '../agent-profile/agent-profile-view';
import { ToastContainer } from 'react-toastify';
import SalesView from '../sales/sales-vew';
import EmailTemplatesView from '../template/emailtemplates-view';

// // Any configurations are optional
// configureDevtool( {
// 	// Turn on logging changes button programmatically:
// 	logEnabled: true,
// 	// Turn off displaying conponents' updates button programmatically:
// 	updatesEnabled: false,
// 	// Log only changes of type `reaction`
// 	// (only affects top-level messages in console, not inside groups)
// 	logFilter: change => change.type === 'reaction',
// } );

@inject(['appStore'])
@observer
export default class App extends Component {
    constructor(props) {
        super(props);
        this.props.appStore.analytics.init();
    }

    renderPage(viewStore) {
        if (!appStore.permissionStore.can(`${viewStore.page}.view`)) {
            return <div>Permission denied</div>;
        }

        switch (viewStore.page) {
            case Cons.pages.dashBoard:
                return <DashBoardView />;
            case Cons.pages.files:
                return <FilesView />;
            case Cons.pages.fileDetail:
                return <FileDetailView />;
            case Cons.pages.reports:
                return <ReportsView />;
            case Cons.pages.coordinators:
                return <TcsView />;
            case Cons.pages.agents:
                return <AgentView />;
            case Cons.pages.agentProfile:
                return <AgentProfileView />;
            case Cons.pages.makeListing:
                return <MakeListingView />;
            case Cons.pages.makeTransaction:
                return <MakeTransactionView />;
            case Cons.pages.salesAgents:
                return <SalesView />;
            case Cons.pages.emailTemplates:
                return <EmailTemplatesView />;
        }
    }

    render() {
        return (
            <div className="App" style={{ width: '100%', height: '100%' }}>
                <Header />
                <div className="container-fluid container-fixed-lg bg-white">
                    <ToastContainer />
                    <LoadingIndicator isLoading={appStore.isLoading} />
                    {appStore.viewStore.isUserLoaded ? (
                        <div className="container" style={{ width: '90%' }}>
                            <MainTabs />
                            {this.renderPage(appStore.viewStore)}
                        </div>
                    ) : (
                        <h1 className="center-text">Loading...</h1>
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app-main/app.js